import React from "react";
import CustomCard from "../../../shared/Card/CustomCard";
import MenuForm from "./MenuForm";

export default function AddMenu({ name }) {
  return (
    <CustomCard title={name}>
      <MenuForm type="ADD" />
    </CustomCard>
  );
}
